import React, { useEffect, useState } from "react";
import MainCalculatorsList from "../MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { CalculatorsType } from "../ConstantsEN";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import { Button, MenuItem, Select, TextField } from "@mui/material";
const TITLE = "Google AdSense Calculator - Calculate Your AdSense Revenue";
const DESCRIPTION =
  "Free Google AdSense Calculator helps you calculate your AdSense revenue - find out how much money your website can make. This tool uses data from Google.";
const KEYWORDS =
  "Google AdSense calculator,AdSense revenue calculator, calculate AdSense earnings, AdSense revenue settings, Google AdSense program, calculate daily earnings from Google AdSense, online advertising profit";
const OG_URL = "https://do-calculate.com/calculator/en/google-adsense/";
const conversionMap = {
  day: 1,
  week: 7,
  month: 30.436875,
  year: 365.2425,
};
const GoogleAdseneCalculator = () => {
  const [adImpressions, setAdImpressions] = useState("");
  const [numberOfClicks, setNumberOfClicks] = useState("");
  const [googleAdseneRevenue, setGoogleAdseneRevenue] = useState("");
  const [conversionImpressions, setConversionImpressions] = useState("day");
  const [conversionClicks, setConversionClicks] = useState("day");
  const [conversionRevenue, setConversionRevenue] = useState("day");
  const [adsPerPage, setAdsPerPage] = useState("");
  const [CTR, setCTR] = useState("");
  const [CPC, setCPC] = useState("");
  const [pageViews, setPageViews] = useState("");
  const [selectedConversion, setSelectedConversion] = useState("day");
  const [convertedViews, setConvertedViews] = useState("");
  const handlePageViewsChange = (event) => {
    const views = event.target.value;
    if (/^\d*$/.test(views)) {
      setPageViews(views);
      if (views && conversionMap[selectedConversion]) {
        const conversionFactor = conversionMap[selectedConversion];
        const converted = views * conversionFactor;
        setConvertedViews(converted);
      } else {
        setConvertedViews("");
      }
    }
  };
  const handleConversionChange = (event) => {
    const conversion = event.target.value;
    setSelectedConversion(conversion);
    if (pageViews && conversionMap[conversion]) {
      const conversionFactor = conversionMap[conversion];
      const converted = pageViews * conversionFactor;
      setConvertedViews(converted);
    } else {
      setConvertedViews("");
    }
  };
  const handleAdsPerPageChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setAdsPerPage(value);
    }
  };
  const handleCTRChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setCTR(value);
    }
  };
  const handleCPCChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setCPC(value);
    }
  };
  const handleConversionImpressionsChange = (event) => {
    setConversionImpressions(event.target.value);
    if (adImpressions) {
      const impressions =
        (adImpressions / conversionMap[conversionImpressions]) *
        conversionMap[event.target.value];
      setAdImpressions(Math.round(impressions));
    }
  };
  const handleConversionClicksChange = (event) => {
    setConversionClicks(event.target.value);
    if (numberOfClicks) {
      const clicks =
        (numberOfClicks / conversionMap[conversionClicks]) *
        conversionMap[event.target.value];
      setNumberOfClicks(Math.round(clicks));
    }
  };
  const handleConversionRevenueChange = (event) => {
    setConversionRevenue(event.target.value);
    if (googleAdseneRevenue) {
      const revenue =
        (googleAdseneRevenue / conversionMap[conversionRevenue]) *
        conversionMap[event.target.value];
      setGoogleAdseneRevenue(Math.round(revenue));
    }
  };
  useEffect(() => {
    if (pageViews && adsPerPage) {
      const impressions = Number(convertedViews) * Number(adsPerPage);
      setAdImpressions(impressions);
    }
  }, [pageViews, adsPerPage]);
  useEffect(() => {
    const convertedCTR = Number(CTR) / 100;
    const clicks = Number(pageViews) * Number(adsPerPage) * convertedCTR;
    setNumberOfClicks(clicks);
  }, [pageViews, adsPerPage, CTR]);
  useEffect(() => {
    const convertedCTR = Number(CTR) / 100;
    const googleRevenue =
      Number(pageViews) * Number(adsPerPage) * convertedCTR * Number(CPC);
    setGoogleAdseneRevenue(googleRevenue);
  }, [pageViews, adsPerPage, CTR, CPC]);
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="row">
            <div>
              <p>
                Explore the potential of your Google AdSense revenue with our
                Google AdSense Calculator. Estimate your earnings effortlessly
                and gain insights into your online advertising income. Our
                Google AdSense Calculator is a powerful tool that allows you to
                calculate your revenue for free, providing valuable information
                to optimize your monetization strategy
              </p>
              <h2 style={{ fontSize: "18px" }}>What is Google AdSense:</h2>
              <p>
                Google AdSense is a program developed by Google that allows
                website publishers to generate income from their content by
                displaying targeted advertisements on their web pages.
                Advertisers bid on ad space, and Google matches relevant ads to
                the content of the website.
              </p>
              <p>
                How does Google AdSense work? When a visitor clicks on an ad,
                the website publisher earns a portion of the revenue generated
                by the advertiser. AdSense is one of the most popular online
                advertising programs and can be a significant source of income
                for website owners with a substantial amount of traffic.
                Additionally, joining Google AdSense is free, easy to set up,
                and manage.
              </p>
              <p>
                How are Google AdSense earnings calculated? To calculate the
                number of ad impressions, multiply the pageviews by the number
                of ads on each page. To calculate the number of clicks, multiply
                the ad impressions by the click-through rate (CTR). Google
                AdSense revenue is then calculated by multiplying the pageviews
                by the number of ads per page, CTR, and cost per click (CPC), as
                follows:
                <br />
                Google AdSense revenue = pageviews × ads per page × CTR × CPC
              </p>
              <p>
                Alternatively, Google AdSense earnings can be calculated using
                the following formula:
              </p>
              <hr />
            </div>
          </div>
          <MobileUnderCalAds />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <h3
                className="p-3 mb-2 bg-success text-white"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                AdSense Revenue Calculator Tool
              </h3>
              <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                <TextField
                  label="Page Views"
                  name="pageViews"
                  value={pageViews}
                  onChange={handlePageViewsChange}
                  sx={{
                    width: "200px",
                    ml: "10px",
                    bgcolor: "#f9f9f9",
                    "&  .MuiFormHelperText-root.Mui-error": {
                      backgroundColor: "rgb(229, 230, 227) !important",
                      margin: 0,
                      padding: "8px 0 0 41px",
                    },
                  }}
                  size="small"
                  color="success"
                />
                <Select
                  value={selectedConversion}
                  onChange={handleConversionChange}
                  size="small"
                  color="success"
                  style={{
                    backgroundColor: "#f9f9f9",
                    fontSize: "12px",
                    padding: "2px 0",
                  }}
                >
                  <MenuItem value="day">Per day</MenuItem>
                  <MenuItem value="week">Per week</MenuItem>
                  <MenuItem value="month">Per month</MenuItem>
                  <MenuItem value="year">Per year</MenuItem>
                </Select>
              </div>
              {convertedViews && (
                <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                  <TextField
                    label="مشاهدات الصفحة بعد التحويل"
                    value={convertedViews}
                    sx={{
                      width: "200px",
                      ml: "10px",
                      bgcolor: "#f9f9f9",
                      "&  .MuiFormHelperText-root.Mui-error": {
                        backgroundColor: "rgb(229, 230, 227) !important",
                        margin: 0,
                        padding: "8px 0 0 41px",
                      },
                    }}
                    size="small"
                    color="success"
                  />
                  <div
                    style={{
                      borderRadius: "4px",
                      border: " 1px solid rgba(0, 0, 0, 0.23)",
                      backgroundColor: "#f9f9f9",
                      padding: "7.5px 12px",
                      userSelect: "none",
                      fontSize: "14px",
                    }}
                  >
                    Per {selectedConversion}
                  </div>
                </div>
              )}
              <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                <TextField
                  label="Number of ads"
                  name="adsPerPage"
                  value={adsPerPage}
                  onChange={handleAdsPerPageChange}
                  sx={{
                    width: "200px",
                    ml: "10px",
                    bgcolor: "#f9f9f9",
                    "&  .MuiFormHelperText-root.Mui-error": {
                      backgroundColor: "rgb(229, 230, 227) !important",
                      margin: 0,
                      padding: "8px 0 0 41px",
                    },
                  }}
                  size="small"
                  color="success"
                />
                <div
                  style={{
                    borderRadius: "4px",
                    border: " 1px solid rgba(0, 0, 0, 0.23)",
                    backgroundColor: "#f9f9f9",
                    padding: "7.5px 12px",
                    userSelect: "none",
                    fontSize: "14px",
                  }}
                >
                  Per Page
                </div>
              </div>
              <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                <TextField
                  label="Ad impressions"
                  value={adImpressions}
                  sx={{
                    width: "200px",
                    ml: "10px",
                    bgcolor: "#f9f9f9",
                    "&  .MuiFormHelperText-root.Mui-error": {
                      backgroundColor: "rgb(229, 230, 227) !important",
                      margin: 0,
                      padding: "8px 0 0 41px",
                    },
                  }}
                  size="small"
                  color="success"
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <Select
                  value={conversionImpressions}
                  onChange={handleConversionImpressionsChange}
                  size="small"
                  color="success"
                  style={{
                    backgroundColor: "#f9f9f9",
                    fontSize: "12px",
                    padding: "2px 0",
                  }}
                >
                  <MenuItem value="day">Per day</MenuItem>
                  <MenuItem value="week">Per week</MenuItem>
                  <MenuItem value="month">Per month</MenuItem>
                  <MenuItem value="year">Per year</MenuItem>
                </Select>
              </div>
              <hr />
              <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                <TextField
                  label="Click through rate (CTR)"
                  name="CTR"
                  value={CTR}
                  onChange={handleCTRChange}
                  sx={{
                    width: "200px",
                    ml: "10px",
                    bgcolor: "#f9f9f9",
                    "&  .MuiFormHelperText-root.Mui-error": {
                      backgroundColor: "rgb(229, 230, 227) !important",
                      margin: 0,
                      padding: "8px 0 0 41px",
                    },
                  }}
                  size="small"
                  color="success"
                />
                <div style={{ fontSize: "20px" }}>%</div>
              </div>
              <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                <TextField
                  label="Number of clicks"
                  value={numberOfClicks}
                  sx={{
                    width: "200px",
                    ml: "10px",
                    bgcolor: "#f9f9f9",
                    "&  .MuiFormHelperText-root.Mui-error": {
                      backgroundColor: "rgb(229, 230, 227) !important",
                      margin: 0,
                      padding: "8px 0 0 41px",
                    },
                  }}
                  size="small"
                  color="success"
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <Select
                  value={conversionClicks}
                  onChange={handleConversionClicksChange}
                  size="small"
                  color="success"
                  style={{
                    backgroundColor: "#f9f9f9",
                    fontSize: "12px",
                    padding: "2px 0",
                  }}
                >
                  <MenuItem value="day">Per day</MenuItem>
                  <MenuItem value="week">Per week</MenuItem>
                  <MenuItem value="month">Per month</MenuItem>
                  <MenuItem value="year">Per year</MenuItem>
                </Select>
              </div>
              <hr />
              <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                <TextField
                  label="Cost per click (CPC) "
                  name="CPC"
                  value={CPC}
                  onChange={handleCPCChange}
                  sx={{
                    width: "200px",
                    ml: "10px",
                    bgcolor: "#f9f9f9",
                    "&  .MuiFormHelperText-root.Mui-error": {
                      backgroundColor: "rgb(229, 230, 227) !important",
                      margin: 0,
                      padding: "8px 0 0 41px",
                    },
                    "& .MuiInputLabel-root": {
                      textAlign: "right",
                    },
                  }}
                  size="small"
                  color="success"
                />
                <div style={{ fontSize: "20px" }}>$</div>
              </div>
              <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                <TextField
                  label="Google Adsense "
                  value={`${googleAdseneRevenue} $`}
                  sx={{
                    width: "200px",
                    ml: "10px",
                    bgcolor: "#f9f9f9",
                    "&  .MuiFormHelperText-root.Mui-error": {
                      backgroundColor: "rgb(229, 230, 227) !important",
                      margin: 0,
                      padding: "8px 0 0 41px",
                    },
                  }}
                  size="small"
                  color="success"
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <Select
                  value={conversionRevenue}
                  onChange={handleConversionRevenueChange}
                  size="small"
                  color="success"
                  style={{
                    backgroundColor: "#f9f9f9",
                    fontSize: "12px",
                    padding: "2px 0",
                  }}
                >
                  <MenuItem value="day">Per day</MenuItem>
                  <MenuItem value="week">Per week</MenuItem>
                  <MenuItem value="month">Per month</MenuItem>
                  <MenuItem value="year">Per year</MenuItem>
                </Select>
              </div>
              <hr />
              <div className="mb-3">
                <Button
                  sx={{
                    backgroundColor: "rgb(108,117,125)",
                    fontSize: "15px",
                    marginRight: "25px",
                    padding: "5px 25px",
                    color: "white",
                  }}
                  onClick={() => {
                    setAdImpressions("");
                    setNumberOfClicks("");
                    setGoogleAdseneRevenue("");
                    setPageViews("");
                    setAdsPerPage("");
                    setCTR("");
                    setCPC("");
                    setConvertedViews("");
                    setConversionImpressions("day");
                    setConversionClicks("day");
                    setConversionRevenue("day");
                  }}
                >
                  Clear
                </Button>
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList
            CalculatorsTypeId={CalculatorsType.financialCalculators}
          ></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
};
export default GoogleAdseneCalculator;
